module.exports = __webpack_public_path__ + "static/img/jizhong3.7b0b4d49.webp";